import React, { useMemo } from "react";
import { Button, Divider, Modal, Checkbox } from "antd";
import TextInfo from "../../../../components/common/TextInfo/TextInfo";
import convertCondition from "../../../../components/helpers/convertCondition";

const ModalUploadDocument = ({
    visible,
    handleCancel,
    handleSave,
    errors,
    onImageChange,
    handleUploadImage,
    sbgPicture,
    recipientKtp,
    customerKtp,
    detail,
    isSameRecipient,
    setIsSameRecipient,
    submitting
}) => {
    return (
        <Modal
            className="modal-form"
            title={"Dokumen Pelunasan"}
            visible={visible}
            onCancel={handleCancel}
            width={600}
            centered
            footer={[
                <Button
                    disabled={submitting}
                    key="submit"
                    type="primary"
                    onClick={handleSave}
                    className="btn-modal"
                >
                    Tambah
                </Button>
            ]}
        >
            <div className="modal-form-content" style={{ gap: "5px" }}>
                <TextInfo
                    title="No. SBG"
                    value={detail?.sbg_code}
                />
                <TextInfo
                    title="Nama Nasabah"
                    value={detail?.ktp_name}
                />
                <TextInfo
                    title="No. Tlp Nasabah"
                    value={detail?.phone_1}
                />
                <TextInfo
                    title="Barang Jaminan"
                    value={detail?.product_details}
                />
                <TextInfo
                    title="Kondisi"
                    value={convertCondition(detail)} />
                {detail?.gadai_type === 'smartphone' &&
                    <TextInfo
                        title="No. IMEI"
                        value={detail?.gadai_smartphone?.imei_number}
                    />
                }
            </div>
            <Divider dashed className="detail-divider" />
            <div className="modal-form-content" style={{ gap: "5px" }}>
                <TextInfo
                    title="SBG Pelunasan"
                    type={"upload"}
                    id={"sbgPicture"}
                    helperText="Format JPG/JPEG/PNG/PDF (Maks. 1MB)"
                    handleImageChange={onImageChange("sbgPicture")}
                    customRequest={handleUploadImage("sbgPicture")}
                    fileList={sbgPicture}
                    error={errors?.sbgPicture}
                    isForm
                />
            </div>
            <div className="modal-form-content" style={{ gap: "5px" }}>
                <TextInfo
                    title="KTP Nasabah"
                    type={"upload"}
                    id={"customerKtp"}
                    helperText="Format JPG/JPEG/PNG/PDF (Maks. 1MB)"
                    handleImageChange={onImageChange("customerKtp")}
                    customRequest={handleUploadImage("customerKtp")}
                    fileList={customerKtp}
                    error={errors?.customerKtp}
                    isForm
                />
            </div>


            <div className="modal-form-content" style={{ gap: "5px", marginBottom: 10 }}>
                <TextInfo
                    title="KTP Penerima"
                    value={<Checkbox
                        className="outlet-all-checkbox"
                        checked={isSameRecipient}
                        onChange={(i) => setIsSameRecipient(i.target.checked)}
                    >
                        <div>Diterima oleh nasabah</div>
                    </Checkbox>}
                />
            </div>

            <div className="modal-form-content" style={{ gap: "5px" }}>
                <TextInfo
                    disabled={isSameRecipient}
                    title=""
                    type={"upload"}
                    id={"recipientKtp"}
                    helperText="Format JPG/JPEG/PNG/PDF (Maks. 1MB)"
                    handleImageChange={onImageChange("recipientKtp")}
                    customRequest={handleUploadImage("recipientKtp")}
                    fileList={recipientKtp}
                    error={errors?.recipientKtp}
                    isForm
                />
            </div>
        </Modal>
    );
};

export default ModalUploadDocument;
